interface QuickActionProps {
  label: string;
  icon: string;
  colorClass: string;
  onClick?: () => void;
}

export default function QuickAction({ label, icon, colorClass, onClick }: QuickActionProps) {
  return (
    <button
      onClick={onClick}
      className={`flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${colorClass}`}
    >
      <span className="w-4 h-4 flex items-center justify-center">
        <i className={`${icon} text-sm`}></i>
      </span>
      {label}
    </button>
  );
}